(function () {
  "use strict";

  if (window.HDProductReviewProof) {
    window.HDProductReviewProof.initAll(document);
    return;
  }

  var FETCH_TIMEOUT_MS = 5000;
  var WIDGET_TIMEOUT_MS = 8000;
  var WIDGET_POLL_MS = 100;
  var NORMALIZE_WATCH_MS = 10000;
  var NORMALIZE_DEBOUNCE_MS = 50;

  function parseResponse(payload, productId) {
    var response = payload && payload.response;
    var bottomline = response && response.bottomline;
    var products = response && response.products;
    var reviews = response && response.reviews;
    var count = Number(bottomline && bottomline.total_review);
    var productMatches = Array.isArray(products) && products.some(function (product) {
      return String(product && product.domain_key) === String(productId);
    });

    if (!productMatches || !Number.isInteger(count) || count < 1) {
      return null;
    }

    return {
      count: count,
      hasIncentivized: Array.isArray(reviews) && reviews.some(function (review) {
        return review && review.is_incentivized === true;
      })
    };
  }

  function buildSummary(summary, wrapper) {
    var link = document.createElement("a");
    var star = document.createElement("span");
    var text = document.createElement("span");
    var target = summary.getAttribute("data-review-target") || wrapper.id;

    link.className = "hd-product-review-summary__link";
    link.href = "#" + target;
    link.setAttribute("aria-label", "Read product-specific customer reviews.");

    star.className = "hd-product-review-summary__star";
    star.setAttribute("aria-hidden", "true");
    star.textContent = "★";
    text.textContent = "Read customer reviews";

    link.appendChild(star);
    link.appendChild(text);
    summary.textContent = "";
    summary.appendChild(link);
  }

  function widgetHasProof(widget) {
    return Boolean(widget.querySelector(".yotpo-review-card, .yotpo-review, [data-review-id]"));
  }

  function setImportantStyle(node, property, value) {
    if (!node) return;
    if (node.style.getPropertyValue(property) === value && node.style.getPropertyPriority(property) === "important") return;
    node.style.setProperty(property, value, "important");
  }

  function normalizeReviewListHeight(widget, mainLayout) {
    var list = widget.querySelector(".yotpo-reviews-cart-list");
    var node;

    if (!list || !mainLayout || !mainLayout.contains(list)) return;

    node = list.parentElement;
    while (node) {
      setImportantStyle(node, "height", "auto");
      setImportantStyle(node, "min-height", "0");
      setImportantStyle(node, "overflow", "visible");
      if (node === mainLayout) break;
      node = node.parentElement;
    }
  }

  function normalizeWidgetLayout(widget) {
    var mainLayout = widget.querySelector(".yotpo-main-widget-layout");
    var baseLayout = widget.querySelector(".yotpo-base-layout");
    var header = widget.querySelector(".yotpo-header-container");

    setImportantStyle(mainLayout, "box-sizing", "border-box");
    setImportantStyle(mainLayout, "clear", "both");
    setImportantStyle(mainLayout, "float", "none");
    setImportantStyle(mainLayout, "margin-left", "clamp(20px, 5%, 40px)");
    setImportantStyle(mainLayout, "margin-right", "clamp(20px, 5%, 40px)");
    setImportantStyle(mainLayout, "text-align", "left");
    setImportantStyle(mainLayout, "width", "auto");

    setImportantStyle(baseLayout, "margin-left", "0");
    setImportantStyle(baseLayout, "margin-right", "0");
    setImportantStyle(baseLayout, "text-align", "left");
    setImportantStyle(baseLayout, "width", "100%");

    setImportantStyle(header, "align-self", "flex-start");
    setImportantStyle(header, "display", "inline-flex");
    setImportantStyle(header, "flex", "0 0 auto");
    setImportantStyle(header, "inline-size", "auto");
    setImportantStyle(header, "max-width", "100%");
    setImportantStyle(header, "width", "auto");

    normalizeReviewListHeight(widget, mainLayout);
  }

  function placeCopyrightAfterReviews(wrapper) {
    var section = wrapper.closest(".product-template__container") || document;
    var copyright = section.querySelector("[data-hd-product-copyright]");

    if (!copyright) return;
    wrapper.insertAdjacentElement("afterend", copyright);
    copyright.setAttribute("data-hd-after-reviews", "true");
  }

  function yotpoInitializer() {
    if (window.yotpo && typeof window.yotpo.initWidgets === "function") {
      return function () { window.yotpo.initWidgets(); };
    }
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
      return function () { window.yotpoWidgetsContainer.initWidgets(); };
    }
    return null;
  }

  function failClosed(wrapper, summary, widget) {
    wrapper.hidden = true;
    wrapper.removeAttribute("data-state");
    wrapper.setAttribute("aria-hidden", "true");
    summary.hidden = true;
    summary.textContent = "";
    widget.classList.remove("yotpo", "yotpo-main-widget");
    widget.textContent = "";
  }

  function startWidget(wrapper, summary, widget) {
    var startedAt = Date.now();
    var observer;
    var poll;
    var normalizeTimer;
    var observerStopTimer;
    var done = false;
    var initCalled = false;

    function scheduleNormalize() {
      if (!done) return;
      window.clearTimeout(normalizeTimer);
      normalizeTimer = window.setTimeout(function () {
        normalizeWidgetLayout(widget);
      }, NORMALIZE_DEBOUNCE_MS);
    }

    function handleMutation() {
      if (!done) {
        finishReady();
        return;
      }
      scheduleNormalize();
    }

    function finishReady() {
      if (done || !widgetHasProof(widget)) return false;
      done = true;
      window.clearTimeout(poll);
      normalizeWidgetLayout(widget);
      window.setTimeout(function () { normalizeWidgetLayout(widget); }, 500);
      if (observer) {
        observerStopTimer = window.setTimeout(function () {
          observer.disconnect();
          window.clearTimeout(normalizeTimer);
        }, NORMALIZE_WATCH_MS);
      }
      wrapper.setAttribute("data-state", "ready");
      wrapper.removeAttribute("aria-hidden");
      buildSummary(summary, wrapper);
      summary.hidden = false;
      placeCopyrightAfterReviews(wrapper);
      return true;
    }

    function waitForWidget() {
      var init = yotpoInitializer();

      if (done) return;
      if (finishReady()) return;
      if (Date.now() - startedAt >= WIDGET_TIMEOUT_MS) {
        done = true;
        if (observer) observer.disconnect();
        window.clearTimeout(normalizeTimer);
        window.clearTimeout(observerStopTimer);
        failClosed(wrapper, summary, widget);
        return;
      }

      if (init && !initCalled) {
        initCalled = true;
        init();
        if (finishReady()) return;
      }
      poll = window.setTimeout(waitForWidget, WIDGET_POLL_MS);
    }

    wrapper.hidden = false;
    wrapper.setAttribute("data-state", "loading");
    wrapper.setAttribute("aria-hidden", "true");
    widget.classList.add("yotpo", "yotpo-main-widget");

    if (window.MutationObserver) {
      observer = new window.MutationObserver(handleMutation);
      observer.observe(widget, {
        attributes: true,
        attributeFilter: ["class", "style"],
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    waitForWidget();
  }

  function fetchProof(wrapper) {
    var controller = window.AbortController ? new window.AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT_MS) : null;
    var options = {
      cache: "force-cache",
      credentials: "omit",
      headers: { Accept: "application/json" }
    };

    if (controller) options.signal = controller.signal;

    return window.fetch(wrapper.getAttribute("data-api-url"), options)
      .then(function (response) {
        if (!response.ok) throw new Error("Yotpo review lookup failed");
        return response.json();
      })
      .then(function (payload) {
        return parseResponse(payload, wrapper.getAttribute("data-product-id"));
      })
      .catch(function () { return null; })
      .then(function (proof) {
        if (timeout) window.clearTimeout(timeout);
        return proof;
      });
  }

  function initWrapper(wrapper) {
    var section = wrapper.closest(".product-template__container") || document;
    var summary = section.querySelector("[data-hd-product-review-summary]");
    var widget = wrapper.querySelector("[data-hd-yotpo-widget]");

    if (wrapper.getAttribute("data-hd-review-bound") === "true" || !summary || !widget || !window.fetch) return;
    wrapper.setAttribute("data-hd-review-bound", "true");
    failClosed(wrapper, summary, widget);

    fetchProof(wrapper).then(function (proof) {
      if (proof) startWidget(wrapper, summary, widget);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll("[data-hd-product-reviews]"), initWrapper);
  }

  window.HDProductReviewProof = {
    initAll: initAll,
    initWrapper: initWrapper,
    parseResponse: parseResponse
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
